import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
var firebase = require("firebase/app");
import db from '../main.js'
import { integer } from 'vuelidate/lib/validators';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        usuario: '',
        error: '',
        productos: [],
        producto: {},
        carga: false,
        texto: ''
    },
    mutations: {
        setUsuario(state, nuevoUsuario) {
            state.usuario = nuevoUsuario
        },
        setError(state, error) {
            state.error = error
        },
        setProductos(state, productos) {
            state.productos = productos;
        },
        setProducto(state, producto) {
            state.producto = producto;
        },
        eliminarProducto(state, id) {
            state.productos = state.productos.filter(producto => {
                return producto.id != id
            })
        },
        setCarga(state, indicador) {
            state.carga = indicador;
        }
    },
    actions: {
        crearUsuario({ commit }, usuario) {
            firebase.auth().createUserWithEmailAndPassword(usuario.email, usuario.pass1)
                .then((res) => {
                    let usuarioNuevo = {
                        email: res.user.email,
                        uid: res.user.uid
                    }
                    commit('setUsuario', usuarioNuevo);

                    db.collection(res.user.uid).add({
                        NOM_PRODUCTO: 'Producto de Prueba',
                        IMP_UNITARIO: 100,
                        IND_ACTIVO: true,
                        FEC_REGISTRO: new Date()
                    }).then(() => {
                        router.push({
                            name: 'productos'
                        })
                    })
                })
                .catch((err) => {
                    //var errorCode = err.code;
                    commit('setError', err.code)
                });
        },
        ingresoUsuario({ commit }, usuario) {
            firebase.auth().signInWithEmailAndPassword(usuario.email, usuario.pass)
                .then((res) => {
                    let usuarioIngreso = {
                        email: res.user.email,
                        uid: res.user.uid
                    }
                    commit('setUsuario', usuarioIngreso);
                    router.push({
                        name: 'inicio'
                    });
                })
                .catch(function(err) {
                    commit('setError', err.message)
                });
        },
        detectarUsuario({ commit }, usuario) {
            if (usuario == null) {
                commit('setUsuario', null);
            } else {
                let usuarioIngreso = {
                    email: usuario.email,
                    uid: usuario.uid
                }
                commit('setUsuario', usuarioIngreso);
            }
        },
        cerrarSesion({ commit }) {
            firebase.auth().signOut();
            commit('setUsuario', null);
            router.push({
                name: 'ingreso'
            });
        },
        listarProductos({ commit }) {
            commit('setCarga', true);

            const usuario = firebase.auth().currentUser;
            const productos = [];

            db.collection(usuario.uid).get()
                .then(aProducto => {
                    aProducto.forEach(doc => {
                        let producto = doc.data();
                        producto.id = doc.id;
                        producto.FEC_CREACION = new Date(producto.FEC_REGISTRO.seconds * 1000).toLocaleDateString();
                        producto.IMP_UNITARIO = parseFloat(producto.IMP_UNITARIO).toFixed(2);

                        productos.push(producto);
                    })
                    commit('setCarga', false);
                });

            commit('setProductos', productos);
        },
        encontrarProducto({ commit }, id) {

            const usuario = firebase.auth().currentUser;

            db.collection(usuario.uid).doc(id).get()
                .then(doc => {
                    let producto = doc.data();
                    producto.id = doc.id;

                    commit('setProducto', producto);
                });
        },
        editarProducto({ commit }, producto) {
            const usuario = firebase.auth().currentUser;

            db.collection(usuario.uid).doc(producto.id).update({
                NOM_PRODUCTO: producto.NOM_PRODUCTO,
                IMP_UNITARIO: producto.IMP_UNITARIO,
                IND_ACTIVO: producto.IND_ACTIVO
            }).then(() => {
                router.push({
                    name: 'productos'
                })
            })
        },
        crearProducto({ commit }, producto) {

            commit('setCarga', true);

            const usuario = firebase.auth().currentUser;

            db.collection(usuario.uid).add({
                NOM_PRODUCTO: producto.NOM_PRODUCTO,
                IMP_UNITARIO: producto.IMP_UNITARIO,
                IND_ACTIVO: producto.IND_ACTIVO,
                FEC_REGISTRO: new Date()
            }).then(() => {
                router.push({
                    name: 'productos'
                });
                commit('setCarga', true);
            })
        },
        eliminarProducto({ commit }, id) {
            const usuario = firebase.auth().currentUser;

            db.collection(usuario.uid).doc(id).delete()
                .then(() => {
                    commit('eliminarProducto', id)
                })
        },
        buscarProducto({ commit, state }, texto) {
            state.texto = texto.toLowerCase();
        }
    },
    modules: {},
    getters: {
        usuarioExiste(state) {
            if (state.usuario === null || state.usuario === '' || state.usuario == undefined) {
                return false;
            }
            return true;
        },
        productoFiltrado(state) {
            let aProductoFiltrado = [];
            for (let producto of state.productos) {
                let nomProducto = producto.NOM_PRODUCTO.toLowerCase();
                if (nomProducto.indexOf(state.texto) >= 0) {
                    aProductoFiltrado.push(producto);
                }
            }
            return aProductoFiltrado;
        }
    }
})